export default __webpack_public_path__ + "static/epica-lite-4-c0f69e001aa9b65d4001f4edf5feac2a.jpg";